import { mapDeviceAuthenticationStateFromSysApi } from '@shure/shared/angular/data-access/device-authentication';
import { mapFragmentFeaturesToModel } from '@shure/shared/angular/data-access/system-api/mappers';
import { DeviceAuthentication, DeviceAuthenticationState } from '@shure/shared/angular/data-access/system-api/models';

import { CdmDeviceUiDevice } from '../../api/models/cdm-device-ui-device';
import { CdmDeviceUiDeviceFragment } from '../graphql/generated/cdm-device-ui.generated';

export function mapCdmDeviceUiDeviceFromSysApi(fragment: CdmDeviceUiDeviceFragment): CdmDeviceUiDevice {
	return {
		id: fragment.id,
		features: mapFragmentFeaturesToModel(fragment, {
			authentication: () => mapAuthenticationFromSysApi(fragment.features.authentication),
			proxyDevice: () => ({
				deviceId: fragment.features.proxyDevice?.device?.id
			})
		})
	};
}

function mapAuthenticationFromSysApi(
	fragment: CdmDeviceUiDeviceFragment['features']['authentication']
): DeviceAuthentication {
	const authentication: DeviceAuthentication = {
		authenticated: false, // Device-level authentication is not supported for Cloud-managed devices
		state: DeviceAuthenticationState.InitializedNotSet,
		enabled: false,
		readonlyModeSelected: false,
		enabledButNotAuthenticated: false
	};

	if (fragment?.credentials && fragment.credentials.length === 1) {
		const state = mapDeviceAuthenticationStateFromSysApi(fragment.credentials[0].credentialsState);
		authentication.state = state;
		authentication.enabled = state === DeviceAuthenticationState.Set;
	}

	authentication.enabledButNotAuthenticated = authentication.enabled && !authentication.authenticated;
	return authentication;
}
